import { UNIT } from '../../../../constant/unit'
import { HEIGHT_UNIT_METER_PER_FOOT } from '../../constants/unit'
import { getImperialInchesHeightUntil } from '../get-imperial-inches'

export function getMetersHeightUtil (height, heightUnit) {
  if (heightUnit === UNIT.METRIC) {
    return height
  }
  const inches = getImperialInchesHeightUntil(height)
  if (inches && inches < 10) {
    // e.g.
    // `height` = 5.09
    // `inches` = 9
    // new `height` = 5.9
    height = (
      parseInt(height, 10) +
      (
        inches / 10
      )
    )
  }
  return parseFloat((
    height * HEIGHT_UNIT_METER_PER_FOOT
  ).toFixed(2))
}
